<template>
  <span class="yCenter pa-5">
    <div class="mr-5">
      {{ $t('sale.sale_sale-number') }}： {{ items.transaction.controlNumber }}
    </div>
    <div class="mr-5">
      {{ $t('sale.sale_remittance-number') }}：
      {{ Number(items.remittanceNumber) }}
    </div>
    <div class="mr-5" v-if="items.paymentDate">
      {{ $t('sale.sale_sale-payment-date') }}： {{ items.paymentDate }}
    </div>
    <div class="mr-5" v-if="items.shipDate">
      {{ $t('sale.sale_ship-destdate') }}： {{ items.shipDate }}
    </div>
    <div class="mr-5" v-if="items.compDate">
      {{ $t('sale.sale_completion-date') }}： {{ items.compDate }}
    </div>
    <div class="mr-5" v-if="items.exOrderNumber">
      {{ $t('sale.sale_ec-sale-number') }}： {{ items.exOrderNumber }}
    </div>
    <div class="mr-5" v-if="items.customerOrderStatusHistory">
      {{ $t('sale.sale_external-order-id') }}： {{ items.customerOrderStatusHistory.externalOrderId }}
    </div>
  </span>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  components: {},
  props: {
    items: { default: {} }
  },
  data: () => ({
    // shipList: {}
  }),
  // async created() {
  //   this.shipList = await this.getShipListFromApi({
  //     salesControlNumber: this.items.transaction.controlNumber
  //   })
  // },
  methods: {
    // ...mapActions('Ship', ['getShipListFromApi'])
  },
  computed: {}
}
</script>
<style lang="scss" scoped></style>
